import { MenuEntry } from 'polyquail-uikit'

const config: MenuEntry[] = [
  {
    label: 'All Layers',
    icon: 'LayerIcon',
    items: [
      {
        label: 'Layer1-KWIL (finished)',
        href: 'https://kwil.polyquail.finance/',
      },
      {
        label: 'Layer2-KEGG (finished)',
        href: 'https://kegg.polyquail.finance/',
      },
      {
        label: 'Layer3-CHK (finished)',
        href: 'https://chk.polyquail.finance/',
      },
    ],
  },
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        // TODO 11
        label: 'Buy KWIL',
        href: 'https://quickswap.exchange/#/swap?outputCurrency=0x252656AdC9E22C697Ce6c08cA9065FBEe5E394e7',
      },
      {
        // TODO 12
        label: 'Add KWIL-USDC',
        href:
          'https://quickswap.exchange/#/add/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/0x252656AdC9E22C697Ce6c08cA9065FBEe5E394e7',
      },
      {
        // TODO 13
        label: 'Add KWIL-WMATIC',
        href:
          'https://quickswap.exchange/#/add/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270/0x252656AdC9E22C697Ce6c08cA9065FBEe5E394e7',
      },
    ],
  },
  {
    label: 'LP Farms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'Token Farms',
    icon: 'PoolIcon',
    href: '/nests',
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    items: [
      {
        label: 'Github',

        href: 'https://github.com/polyquail-finance/',
      },
      {
        label: 'Docs',
        href: 'https://polyquail-finance.gitbook.io/polyquail-finance/',
      },
      {
        label: 'RugDoc Review',
        href: 'https://rugdoc.io/project/polyquail/',
      },
      {
        label: 'vfat.tools',
        href: 'https://vfat.tools/polygon/polyquail_kwil/',
      },
      {
        label: 'DappRadar',
        href: 'https://dappradar.com/polygon/defi/polyquail-finance/',
      },
    ],
  },
  {
    label: 'Audit by Techrate',
    icon: 'AuditIcon',
    href: 'https://polyquail-finance.gitbook.io/polyquail-finance/techrate-audit',
  },
]

export default config
